"use strict";
var core_1 = require("@angular/core");
var TooltipContent_1 = require("./TooltipContent");
var Tooltip = (function () {
    // -------------------------------------------------------------------------
    // Constructor
    // -------------------------------------------------------------------------
    function Tooltip(viewContainerRef, resolver) {
        this.viewContainerRef = viewContainerRef;
        this.resolver = resolver;
        this.tooltipAnimation = true;
        this.tooltipPlacement = "bottom";
    }
    // -------------------------------------------------------------------------
    // Public Methods
    // -------------------------------------------------------------------------
    Tooltip.prototype.show = function () {
        if (this.tooltipDisabled || this.visible)
            return;
        this.visible = true;
        if (typeof this.content === "string") {
            var factory = this.resolver.resolveComponentFactory(TooltipContent_1.TooltipContent);
            if (!this.visible)
                return;
            this.tooltip = this.viewContainerRef.createComponent(factory);
            this.tooltip.instance.hostElement = this.viewContainerRef.element.nativeElement;
            this.tooltip.instance.content = this.content;
            this.tooltip.instance.placement = this.tooltipPlacement;
            this.tooltip.instance.animation = this.tooltipAnimation;
        }
        else {
            var tooltip = this.content;
            tooltip.hostElement = this.viewContainerRef.element.nativeElement;
            tooltip.placement = this.tooltipPlacement;
            tooltip.animation = this.tooltipAnimation;
            tooltip.show();
        }
    };
    Tooltip.prototype.hide = function () {
        if (!this.visible)
            return;
        this.visible = false;
        if (this.tooltip)
            this.tooltip.destroy();
        if (this.content instanceof TooltipContent_1.TooltipContent)
            this.content.hide();
    };
    Tooltip.decorators = [
        { type: core_1.Directive, args: [{
                    selector: "[tooltip]"
                },] },
    ];
    /** @nocollapse */
    Tooltip.ctorParameters = function () { return [
        { type: core_1.ViewContainerRef, },
        { type: core_1.ComponentFactoryResolver, },
    ]; };
    Tooltip.propDecorators = {
        'content': [{ type: core_1.Input, args: ["tooltip",] },],
        'tooltipDisabled': [{ type: core_1.Input },],
        'tooltipAnimation': [{ type: core_1.Input },],
        'tooltipPlacement': [{ type: core_1.Input },],
        'show': [{ type: core_1.HostListener, args: ["focusin",] }, { type: core_1.HostListener, args: ["mouseenter",] },],
        'hide': [{ type: core_1.HostListener, args: ["focusout",] }, { type: core_1.HostListener, args: ["mouseleave",] },],
    };
    return Tooltip;
}());
exports.Tooltip = Tooltip;
//# sourceMappingURL=Tooltip.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ng2-tooltip/Tooltip.js
// module id = 105
// module chunks = 1